module.exports = __webpack_public_path__ + "fonts/Open-Sans.60047f87.woff2";